import gql from 'graphql-tag';

export const GET_ELIGIBLE_FINANCE_PROGRAMS = gql`
  query GetEligibleFinancePrograms($accountId: ID!, $creditSubmissionId: ID!) {
    eligibleFinancePrograms(accountId: $accountId, creditSubmissionId: $creditSubmissionId) {
      success
      error
      list {
        financeProgramId
        accountId
        nameInternal
        eligibleCategory
        paymentOptionsConfiguration
        prescreenCriteria {
          prescreenCriteriaId
          name
        }
        scoreTiers {
          tiers
        }
      }
    }
  }
`;
